<template>
  <div class="myselfBadge">
    <div class="content">
      <div class="left">
        <div class="top">
          <img src="static/img/class/myBadge/medal.png" alt class="medal">
        </div>
        <p class="title">我的徽章</p>
        <p>
          已获得
          <span>{{badgeNum}}</span> 枚
        </p>
      </div>
      <div class="right">
        <div class="mask"></div>
        <div class="tabBox" v-if="badgeList.length>1">
          <div class="tab">
            <span
              ref="item"
              v-for="(item,index) in badgeList"
              :class="{'focustxt':currentIndex==index}"
              :key="index"
              @click="tabClick(index)"
            >{{item.type_name}}</span>
          </div>
          <i class="foucstab" :style="{transform:'translateX('+removeDistance[currentIndex]+'px)'}"></i>
        </div>
        <loadError
          textColor="#999999"
          @loadAgain="getBadgeListAgain"
          :textColor="'#989898'"
          :btnstyle="true"
          v-if="loadErrorShow"
          loadErrorText="徽章列表获取失败，请点击按钮重新加载!"
        />
        <div class="badgeBox" v-show="showData.length>0">
          <div class="badge_items_box" v-for="(item,index) in showData" :key="index">
            <h2>{{item.year}}{{seasonData[item.season]}}</h2>
            <div class="badge_items">
              <div class="badge-item" v-for="(v,index) in item.list" :key="index">
                <div class="img-box">
                  <i v-if="v.is_illume==1&&v.badge_count>1">{{v.badge_count}}</i>
                  <img class='cursor' @click="popupShow(v)" :src="v.path" alt ondragstart="return false;">
                </div>
                <p class="badge-name">{{v.name}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-box" v-show="!loadErrorShow&&showData.length==0">
          <div class="empty">
            <img src="static/img/class/myBadge/noBadage.png" alt>
            <p>还没获得徽章，继续努力吧！</p>
          </div>
        </div>
      </div>
    </div>
    <Back @goBack="goClassList"/>
    <badgepopup v-show="badgepopupShow" @close="closePopup" :popupData="popupData"></badgepopup>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Back from "@/components/basic/back.vue";
import loadError from "../../basic/loadError";
import badgepopup from "./badgepopup";

export default {
  name: "myselfBadge",
  data() {
    return {
      badgeList: [], //徽章列表
      showData: [],
      badgeNum: 0, //徽章总数
      goUserinfo: false, //点击返回是否回到首页,
      currentIndex: 0,
      loadErrorShow: false,
      badgepopupShow:false,
      popupData:{},
      removeDistance: [17],
      seasonData:{
        1:"春季",
        2:"暑假",
        3:"秋季",
        4:"寒假"
      }
    };
  },
  components: { Back, loadError,badgepopup },
  mounted() {
    this.getBadgeList();
    this.goUserinfo = this.$route.query.flag == "userInfo" ? true : false;
  },
  computed: {
    ...mapState(["userID"])
  },
  methods: {
    ...mapActions(["usercenterBadgeList"]),
    popupShow(data){
      this.popupData = {
        badge_msg:data.badge_msg,
        name:data.name,
        path:data.path
      }
      this.badgepopupShow=true;

    },
    closePopup(){
      this.badgepopupShow=false;
      this.popupData = {};
    },
    tabClick(index) {
      this.currentIndex = index;
      this.showData = this.getShowData(index);
    },
    getBadgeListAgain() {
      // this.$root.eventHub.$emit("createLog", {
      //   id: "LMTrackEventFailureButton"
      // });
      this.getBadgeList();
    },
    //徽章列表
    getBadgeList() {
      this.loadErrorShow = false;
      this.usercenterBadgeList().then(({ res, ok }) => {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventMyBadge",
            data: {
              result: res.code || "E_SUCCESS",
              content: res.desc || "操作成功"
            }
          });
          if (ok) {
            let data = res;
            this.badgeNum = data.total_badge;
            for(let item in data.list){
              let newData = {};
              data.list[item].type_list.forEach((item, index) => {
                  let {
                      year,
                      season
                  } = item;
                  let key = year+'_'+season;
                  if (!newData[key]) {
                      newData[key] = {
                          year,
                          season,
                          list: []
                      }
                  }
                  newData[key].list.push(item);
              });
              data.list[item].type_list = Object.values(newData); // list 转换成功的数据
            }
            this.badgeList = data.list;
            this.showData = this.getShowData();
            let result = [];
            let itemArr = [];
            setTimeout(() => {
              itemArr = this.$refs.item || [];
              itemArr.forEach(item => {
                result.push(item.offsetLeft + (item.offsetWidth - 26) / 2);
              });
              this.removeDistance = result;
            }, 0);
          } else {
            this.loadErrorShow = true;
          }
        }).catch(err => {
          this.loadErrorShow = true;
        });
    },
    //返回到班级列表页面
    goClassList() {
      if (this.goUserinfo) {
        this.$router.replace("/userInfo");
      } else {
        this.$router.replace("/class");
      }
    },
    getShowData() {
      let result =this.badgeList.find((ele,index) => {
        return this.currentIndex == index;
      });
      return (result && result.type_list) || [];
    }
  }
};
</script>
<style lang="less">
.myselfBadge {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  background: #007a9c ;
  .content {
    background: #f1f3f4;
    width: 100%;
    height: 100%;
    display: flex;
    .left {
      background: #007a9c;
      min-width: 265px;
      width: 20%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      align-items: center;
      background: #0080c9 url(/static/img/class/myBadge/mainPage-grass.png) no-repeat left bottom;
      background-size: 176px 128px;
      .top {
        position: relative;
        width: 265px;
        height: 334px;
        background: #0080c9 url(/static/img/class/myBadge/linear.png) no-repeat top center;
        background-size: 62px 213px;
        margin-bottom: 52px;
        img {
          position: absolute;
          bottom: -70px;
          left: 45px;
          width: 212px;
          height: 215px;
        }
      }
      p {
        font-size: 36px;
        font-size: 24px;
        color: #D7ECF2;
        margin-bottom: 16px;
        line-height: 24px;
        span {
          color: #fff;
          font-size: 31px;
          font-weight:bold;
        }
      }
      .title {
        font-family: PingFang_Medium;
        letter-spacing: 3px;
        color: #ffffff;
        text-align: center;
        font-size: 36px;
        line-height: 36px;
      }
    }
    .right {
      width: 80%;
      height: 100%;
      position: relative;
      // border-left: 12px solid rgba(0, 122, 156, 0.1);
      display: flex;
      align-items: center;
      flex-direction: column;
      .tabBox {
        font-size: 0;
        text-align: left;
        position: relative;
        .tab {
          height: 74px;
          line-height: 84px;
          padding-top:10px;
          font-size: 24px;
          color: rgba(0,115,174, .7);
          span {
            cursor: pointer;
            margin: 0 32px;
            transition: color 0.2s;
          }
          .focustxt {
            transition: all 0.3s;
            font-weight:600;
            color: rgba(0,115,174, 1);
          }
        }
        .foucstab {
          position: absolute;
          display: inline-block;
          height: 2px;
          width: 26px;
          border-radius:20px;
          background: #007A9C;
          transition: all 0.3s;
        }
      }
      .badgeBox {
        width: 92%;
        margin: 0 auto;
        padding:50px 0;
        height: 100%;
        position: relative;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 0px;
        }
        &::-webkit-scrollbar {
          display: none;
        }
        .badge_items_box{
          text-align:left;
          h2{
            color:#00547e;
            font-size:20px;
            position:relative;
            padding-left:20px;
            min-height:28px;
            &:after{
              content:" ";
              position:absolute;
              width:10px;
              height:10px;
              background:#476A85;
              border-radius:50%;
              top:50%;
              left:0;
              margin-top:-5px;
            }
          }
        }
        .badge_items{
          border-left:1px solid #476A85;
          margin:6px 0 6px 4px;
          padding-top:20px;
          display: inline-flex;
          flex-wrap: wrap;
        }
        .badge-item {
          width: 120px;
          margin:0 10px 10px 35px;
          display:inline-block;
          font-size:0;
          text-align:center;
          .img-box {
            position: relative;
            width: 120px;
            height: 120px;
            text-align: center;
            margin-bottom: 8px;
            i {
              position: absolute;
              height: 26px;
              width: 26px;
              line-height: 26px;
              right: 6px;
              border-radius: 50%;
              top: 0;
              color: #a72350;
              display: inline-block;
              font-size: 18px;
              font-weight: 700;
              background: #ffc71a;
            }
            img {
              width: 120px;
              height: 120px;
              display: block;
              margin: auto;
            }
          }
          .badge-name {
            font-size: 20px;
            color: #00547e;
            max-width: 110px;
            font-family: PingFang_Medium;
            text-align: center;
            word-break: break-all;
            margin: 10px auto 8px auto;
            display: inline-block;
            line-height: 25px;
          }
          .item-type {
            font-size: 15px;
            color: #93a6b4;
            text-align: center;
          }
        }
      }
      .empty-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .empty {
          img {
            width: 384px;
            height: 170px;
          }
          p {
            font-size: 20px;
            text-align: center;
            line-height: 20px;
            color: #b8c3cb;
            margin-top: 32px;
          }
        }
      }
      .mask {
        background: linear-gradient(
          to top,
          rgba(241, 243, 244, 1),
          rgba(241, 243, 244, 0)
        );
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 100px;
        left: 0;
        z-index: 10;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/class/myselfBadge.vue